import React from 'react';
import { VictoryPie } from 'victory';
import { MeasurementHelper } from '../../../lib/helpers/measurementHelper';

const TrafficLightData: React.FC<{ helper: MeasurementHelper }> = ({ helper }) => (
  <div style={{ width: 23, height: 23 }}>
    <VictoryPie
      data={helper.pieChart().data}
      colorScale={helper.pieChart().colorsTrafficLight}
      padding={0}
      labels={[]}
      animate={{
        duration: 500,
        onLoad: { duration: 750 }
      }}
    />
  </div>
);

export default TrafficLightData;
